import gql from 'graphql-tag'

export const DELETE_STUDENTS = gql`
  mutation DeleteStudents ($ids: [ID!]!) {
    removeStudents (students: $ids)
  }
`
